import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Opportunity from "@/services/opportunity/opportunity";
import type { EditOpportunity } from "@/dtos/Opportunity.dto";

export interface EditOpportunityParams {
  id?: string;
  name?: string;
  confidence: string;
  expectedCloseDate: Date | string;
  dealType: string;
  contactId: string;
  ownerId: string;
  opportunityStageId: string;
  organizationId: string;
  leadSourceId?: string;
  products?: any[];
}

/**
 * Composable for editing an opportunity
 */
export function useEditOpportunity() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: EditOpportunityParams) => {
      const payload: EditOpportunity = {
        id: params.id,
        name: params.name,
        status: params.opportunityStageId,
        confidence: params.confidence,
        expectedCloseDate: params.expectedCloseDate as Date,
        owner: params.ownerId,
        dealType: params.dealType,
        contactId: params.contactId,
        organizationId: params.organizationId,
        leadSourceId: params.leadSourceId,
      };

      const result = await Opportunity.editOpportunity(payload);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to edit opportunity");
      }
      return result.data.data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["opportunities"] });
      if (variables.id) {
        queryClient.invalidateQueries({ queryKey: ["opportunity", variables.id] });
      }
      queryClient.invalidateQueries({ queryKey: ["opportunityStages"] });
    },
  });
}
